import * as arrow from 'apache-arrow';
export function parseArrowInBatches(asyncIterator, options) {
  async function* makeArrowAsyncIterator() {
    const readers = arrow.RecordBatchReader.readAll(asyncIterator);
    for await (const reader of readers) {
      for await (const recordBatch of reader) {
        var _options$arrow, _options$arrow2;
        if ((options === null || options === void 0 ? void 0 : (_options$arrow = options.arrow) === null || _options$arrow === void 0 ? void 0 : _options$arrow.batchDebounceMs) !== undefined && (options === null || options === void 0 ? void 0 : (_options$arrow2 = options.arrow) === null || _options$arrow2 === void 0 ? void 0 : _options$arrow2.batchDebounceMs) > 0) {
          await new Promise(resolve => {
            var _options$arrow3;
            return setTimeout(resolve, ((_options$arrow3 = options.arrow) === null || _options$arrow3 === void 0 ? void 0 : _options$arrow3.batchDebounceMs) || 0);
          });
        }
        const arrowTabledBatch = {
          shape: 'arrow-table',
          batchType: 'data',
          data: new arrow.Table([recordBatch]),
          length: recordBatch.data.length
        };
        yield arrowTabledBatch;
      }
      break;
    }
  }
  return makeArrowAsyncIterator();
}
//# sourceMappingURL=parse-arrow-in-batches.js.map